import { FolderOpen } from '@tamagui/lucide-icons';
import { LoaderProps } from '@unistocks/components/loading/spinner/loader';
import { NoDataProps } from '@unistocks/components/no-data/no-data';
import { AsyncState } from '@unistocks/components/query-state/async-state';
import { t } from '@unistocks/shared/localization/index.ts';
import React from 'react';
import { ThemeableStackProps } from 'tamagui';

export type EmptyListProps = ThemeableStackProps & {
  isLoading?: boolean;
  loadingText?: LoaderProps['children'];
  noDataIcon: NoDataProps['Icon'];
  noDataText?: NoDataProps['text'];
} & {
  color?: NoDataProps['color'];
  size?: NoDataProps['size'];
};

export const EmptyList: React.FC<EmptyListProps> = ({
  isLoading,
  loadingText = t('AbpUi::LoadingWithThreeDot'),
  noDataText = t('::NoDataAvailableInDatatable'),
  noDataIcon = FolderOpen,
  ...props
}) => {
  return (
    <AsyncState
      state={isLoading ? 'loading' : 'empty'}
      loadingText={loadingText}
      noDataText={noDataText}
      noDataIcon={noDataIcon}
      {...props}
    />
  );
};

EmptyList.displayName = 'EmptyList';
